export default async function getCroppedImg(
  imageSrc: string,
  crop: { width: number; height: number; x: number; y: number },
  rotation: number = 0, // Agregamos rotación como parámetro
): Promise<Blob> {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('No se pudo obtener el contexto del canvas');
  }

  // Convertir la rotación a radianes
  const rotationInRadians = (rotation * Math.PI) / 180;

  // Calcular el tamaño del canvas considerando la rotación
  const sin = Math.abs(Math.sin(rotationInRadians));
  const cos = Math.abs(Math.cos(rotationInRadians));
  const rotatedWidth = image.width * cos + image.height * sin;
  const rotatedHeight = image.width * sin + image.height * cos;

  canvas.width = rotatedWidth;
  canvas.height = rotatedHeight;

  // Mover el contexto al centro del canvas y rotar
  ctx.translate(rotatedWidth / 2, rotatedHeight / 2);
  ctx.rotate(rotationInRadians);

  // Dibujar la imagen rotada
  ctx.drawImage(image, -image.width / 2, -image.height / 2);

  // Crear un nuevo canvas para el área recortada
  const croppedCanvas = document.createElement('canvas');
  const croppedCtx = croppedCanvas.getContext('2d');

  if (!croppedCtx) {
    throw new Error('No se pudo obtener el contexto del canvas recortado');
  }

  croppedCanvas.width = crop.width;
  croppedCanvas.height = crop.height;

  // Recortar el área seleccionada
  croppedCtx.drawImage(
    canvas,
    crop.x,
    crop.y,
    crop.width,
    crop.height,
    0,
    0,
    crop.width,
    crop.height,
  );

  // Convertir el canvas recortado a un Blob
  return new Promise<Blob>((resolve, reject) => {
    croppedCanvas.toBlob((blob) => {
      if (!blob) {
        return reject(new Error('El canvas está vacío'));
      }
      resolve(blob);
    }, 'image/jpeg');
  });
}

function createImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.setAttribute('crossOrigin', 'anonymous'); // Evita problemas de CORS
    image.onload = () => resolve(image);
    image.onerror = (error) => reject(error);
    image.src = url;
  });
}
